import React, { useMemo } from 'react'

import TabButtonsGroup from 'LuxKit/Tabs/TabButtonsGroup'
import TabButton from 'LuxKit/Tabs/TabButton'
import styled from 'styled-components'
import { rem } from 'polished'

export interface GlobalSearchTab {
  key: App.SearchVertical
  label: string
}

const StyledTabButtonsGroup = styled(TabButtonsGroup)`
  padding: 0 ${rem(16)};
`

interface Props {
  selectedTabKey: App.SearchVertical
  tabs: Map<App.SearchVertical, App.GlobalSearchVerticalTab>
  onTabSelect?: (selectedTab: App.SearchVertical) => void
}

function GlobalSearchTabs(props: Props) {
  const { selectedTabKey, tabs, onTabSelect } = props
  const tabsArray = useMemo(() => [...tabs.entries()], [tabs])

  return <StyledTabButtonsGroup>
    {tabsArray.map(([key, { label, Icon }]) => <TabButton
      size="medium"
      key={key}
      isActive={selectedTabKey === key}
      onClick={() => onTabSelect?.(key)}
      startIcon={<Icon />}
      format="propercase"
    >
      {label}
    </TabButton>)}
  </StyledTabButtonsGroup>
}

export default GlobalSearchTabs
